import { FunctionComponent, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { Check, ContentCopy } from '@mapped/rivet/dist/mui/icons'
import { styled } from '@mapped/rivet/dist/mui/styles'

const GeneratedToken: FunctionComponent<IGeneratedTokenProps> = ({
  newToken,
}) => {
  const [isCopied, setIsCopied] = useState(false)

  const toggleCopy = () => {
    setIsCopied(true)

    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }

  return (
    <GeneratedTokenContainer isCopied={isCopied} className="generated-token">
      {isCopied ? (
        <Copied>Copied!</Copied>
      ) : (
        <CopyNowMessage>
          Copy this token now - it’s your only chance to see it!
        </CopyNowMessage>
      )}
      <TokenWrapper>
        <Token>{newToken}</Token>

        {isCopied ? (
          <Check style={{ marginLeft: '16px' }} color="secondary" />
        ) : (
          <CopyToClipboard text={newToken}>
            <ContentCopy
              onClick={toggleCopy}
              sx={(theme) => ({
                marginLeft: '16px',
                cursor: 'pointer',
                color: theme.palette.text.a70,
              })}
            />
          </CopyToClipboard>
        )}
      </TokenWrapper>
    </GeneratedTokenContainer>
  )
}

const GeneratedTokenContainer = styled.div<{ isCopied: boolean }>`
  background-color: #fcf4db;
  border: 1px solid #f2c94c;
  padding: 16px 24px;

  ${({ isCopied }) =>
    isCopied &&
    `
    background-color: #EEF9F7;
    border: 1px solid #51C0AC;
  `}
`

const Copied = styled.span`
  display: block;
  font-weight: bold;
  font-size: 12px;
  color: #51c0ac;
  margin-bottom: 8px;
`

const CopyNowMessage = styled.span`
  display: block;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 8px;
`

const TokenWrapper = styled.div`
  display: flex;
`

const Token = styled.span`
  color: ${(props) => props.theme.palette.text.primary};
`

interface IGeneratedTokenProps {
  newToken: string
}

export default GeneratedToken
